import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoInfo } from 'src/app/models/logo-info';
import { FeaturesService } from 'src/app/services/features.service';
import { LogosService } from 'src/app/services/logos.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ToastService } from 'src/app/services/toasts.service';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-pdf-export-modal',
    templateUrl: './pdf-export-modal.component.html',
    styleUrls: ['./pdf-export-modal.component.scss'],
    imports: [FormsModule, NgFor, NgIf, AsyncPipe]
})
export class PDFExportModalComponent implements OnInit {
  title: string = '';
  subtitle: string = '';
  dropAnalysis: boolean = true;
  manufacturerReport: boolean = true;
  brandReport: boolean = true;
  segmentReport: boolean = true;
  segmentBreakdownReport: boolean = true;
  top15ProductsReport: boolean = true;
  floatingShelf: boolean = true;
  maxDropsPerPage: number = 5;
  alignShelvesAcrossDrops: boolean = false;
  includeNationalId: boolean = false;
  limitDepthByDOS: boolean = false;
  topLeftLogo = '';
  topRightLogo = '';
  logos: LogoInfo[] = [];
  includeQRCode: boolean = false;

  constructor(
    public activeModal: NgbActiveModal, 
    private toastService: ToastService, 
    private planogramService: PlanogramService,
    private planogramApiService: PlanogramApiService,
    private logosService: LogosService,
    public featuresService: FeaturesService
  ) { }

  ngOnInit(): void {
    this.logosService.getLogos().subscribe(logos => this.logos = logos);
  }

  toggleAllReports(): void {
    const newValue = !this.areAllReportsSelected();
    this.dropAnalysis = newValue;
    this.manufacturerReport = newValue;
    this.brandReport = newValue;
    this.segmentReport = newValue;
    this.segmentBreakdownReport = newValue;
    this.top15ProductsReport = newValue;
    this.floatingShelf = newValue;
  }

  areAllReportsSelected(): boolean {
    return this.dropAnalysis &&
           this.manufacturerReport &&
           this.brandReport &&
           this.segmentReport &&
           this.segmentBreakdownReport &&
           this.top15ProductsReport &&
           this.floatingShelf;
  }

  confirm(): void {
    let message: string = `Exporting Exporting planogram PDF`;
    this.toastService.show(message, { classname: `bg-dark text-light p-3 fs-5`, delay: 5000 })

    let additionalData: any = {
      title: this.title,
      subtitle: this.subtitle,
      maxDropsPerPage: this.maxDropsPerPage,
      alignShelvesAcrossDrops: this.alignShelvesAcrossDrops,
      includeNationalId: this.includeNationalId,
      dropAnalysis: this.dropAnalysis ? "true" : "false",
      manufacturerReport: this.manufacturerReport ? "true" : "false",
      brandReport: this.brandReport ? "true" : "false",
      segmentReport: this.segmentReport ? "true" : "false",
      segmentBreakdownReport: this.segmentBreakdownReport ? "true" : "false",
      top15ProductsReport: this.top15ProductsReport ? "true" : "false",
      floatingShelf: this.floatingShelf ? "true" : "false",
      topLeftLogo: this.topLeftLogo,
      topRightLogo: this.topRightLogo,
      includeQRCode: this.includeQRCode ? "true" : "false",
      limitDepthByDOS: this.limitDepthByDOS ? "true" : "false"
    };
    
    let notes = this.planogramService.getSetting('notes') ?? '';

    if (notes.trim().length > 0) {
      additionalData.notes = notes.trim();
    }

    this.planogramApiService.exportPlanogram(0, 'PDF', additionalData);
    this.activeModal.close(null);
  }

  downloadQrCode(): void {
    this.planogramApiService.downloadQrCode();
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
